import React from 'react';
import Boy from '../../assets/boy.png';
import './landing-page.backstreetboys.form.sass';
import { EmailSubmissionForm } from '../../../../components/email-submission-form/email-submission-form';

export const LandingPageBackstreetboysForm = () => {
  return (
    <div className='vv-landing-page-backstreetboys-form'>
      <div className='vv-landing-page-backstreetboys-form__left'>
        <div className='vv-landing-page-backstreetboys-form__left-container'>
          <div className='vv-landing-page-backstreetboys-form__box vv-landing-page-backstreetboys-form__triangle'>
            <p>Everybody zapraszam do rock your body już 29.10!</p>
          </div>
          <img src={Boy} className='vv-landing-page-backstreetboys-form__image'/>
        </div>
      </div>
      <div className='vv-landing-page-backstreetboys-form__right'>
        <div className='vv-landing-page-backstreetboys-form__right-container'>
          <EmailSubmissionForm/>
        </div>
      </div>
    </div>
  );
};
